export default __webpack_public_path__ + "static/spett1-ce2175ba17f9a87dab987a069196f979.png";